__webpack_require__.p = "/tbilisi-bootcamp/";